import axios, { AxiosResponse } from "axios";
import { isDemo } from "@/utils";
import { getApiEndpoints } from "@/utils/utils";

let instance = null;

class AuthService {
    private sessionToken = "";
    private userId = "";

    constructor() {
        this.sessionToken = localStorage.getItem("stqr_token") || "";
        this.userId = localStorage.getItem("stqr_uid") || "";
    }

    async register(
        firstName: string,
        lasttName: string,
        email: string,
        password: string
    ): Promise<any> {
        if (isDemo()) {
            throw new Error("notInDemo");
        }
        const fd = new FormData();
        fd.append('first_name', firstName);
        fd.append('last_name', lasttName);
        fd.append('email', email);
        fd.append('password', password);
        const gu = await axios.post(getApiEndpoints().CREATE_USER, fd); // gu as geutuser
        if(gu){
            localStorage.setItem("guest", JSON.stringify(gu.data));
        }
        return gu.data;
    }
    

    async login(email: string, password: string): Promise<any> {
        const { token, ssoMode } = await this.getToken(email, password);
        const tokenParts = token.split('.');
        let decodedPayload: any = null;
        let isGuest = false;
        let stqrToken = '';
        if(ssoMode){
            // isGuest already set as faconst tokenParts = res.data.token.split('.');
            decodedPayload = await this.decodeToken(tokenParts[0]);
            stqrToken = JSON.parse(decodedPayload).stqrapi;
        }else{
            decodedPayload = JSON.parse(atob(tokenParts[1]));
            stqrToken = token;
            isGuest = decodedPayload.is_guest;
        }
        if (token) {
            const response = await axios
                .get(`${isGuest ? getApiEndpoints().GUESTS : getApiEndpoints().USERS}/me`, { headers: { Authorization: `Bearer ${token}` } })
                .then(response => response.data);
            return { ...response, stqrToken, isGuest };
        }
    }

    async getToken(email: string, password: string): Promise<{ token: string, ssoMode: boolean }> {
        const fd = new FormData();
        fd.append("email", email);
        fd.append("password", password);
        try {
            // go to sso to check if user exists
            const res = await axios.post(getApiEndpoints().SSO_AUTH, fd);
            
            return { token: res.data.token, ssoMode: true };
        } catch (error) {
            const code = error.response.data.code;
            if(code === 5){
            // go to stqr to check if user exists
                const res = await axios.post(getApiEndpoints().STQR_AUTH, fd);
                return { token: res.data.token, ssoMode: false };
            }
            return null;
        }
    }

    async forgetPassword(email: string): Promise<AxiosResponse> {
        if (isDemo()) {
            throw new Error("notInDemo");
        }
        const fd = new FormData();
        fd.append("email", email);
        try {
            return await axios.post(getApiEndpoints().RESET_PASSWORD_SSO,fd);
        } catch (error) {
            if(error.response.data.code === 2){
                return await axios.post(getApiEndpoints().RESET_PASSWORD_STQR,fd);
            }
            return error.response.data.uid || error.response.data.description;
        }
    }

    async activate(id: number, code: string): Promise<AxiosResponse> {
        if (isDemo()) {
            throw new Error("notInDemo");
        }
        const fd = new FormData();
        fd.append("security_code", code);
        return await axios.post(`${getApiEndpoints().ACTIVATE_USER}/${id}`, fd);
    }
    async decodeToken(token: string): Promise<string> {
        const base64 = token.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const decodedPayload = jsonPayload;
        return decodedPayload;
      }
}

function getInstance(): AuthService {
    if (!instance) {
        instance = new AuthService();
    }

    return instance;
}

export default getInstance;
